import { render, staticRenderFns } from "./Secundario.vue?vue&type=template&id=14b61392&"
import script from "./Secundario.vue?vue&type=script&lang=ts&"
export * from "./Secundario.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports